import axios from "@/utils/axios";
import {
  useInfiniteQuery,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";

export const useUpdateNodeTestInput = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (
      data: {
        id: string;
        value: string | number | boolean | null;
      }[],
    ) => {
      axios.patch("/admin/v1/node/sandbox/input", {
        inputs: data,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["admin-flow-detail"],
      });
    },
  });
};

export const useExecuteNodeInSandbox = () => {
  return useMutation({
    mutationFn: async (nodeId: string) => {
      axios.post(`/admin/v1/node/sandbox/input/execute/${nodeId}`);
    },
  });
};

export const useGetNodeTestInputExecution = (nodeId: string) => {
  return useInfiniteQuery({
    queryKey: ["admin-node-sandbox-execution", nodeId],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await axios.get("/admin/v1/node/sandbox/input/execute", {
        params: {
          filter: {
            node_id: nodeId,
            context: "SANDBOX",
          },
          order_by: "!created_at",
          page: pageParam,
          per_page: 10,
          relationships: [
            "outputs",
            "inputs.conditions.input",
            "inputs.conditions.optionalInput",
            "inputs.calculations.input",
            "inputs.calculations.inputs",
          ].join(","),
        },
      });
      return response.data;
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const { current_page, last_page } = (
        lastPage as {
          meta: { current_page: number; last_page: number };
        }
      ).meta;
      if (current_page < last_page) {
        return current_page + 1;
      }
    },
  });
};
